/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.

This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.

License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.

This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.

For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/
import { FormLabel } from "@mui/material";
import { InputFieldProps } from "../../types/InputProps";
import FormAutoComplete from "../Inputs/FormAutoComplete";
import FormCheckBox from "../Inputs/FormCheckbox";
import FormDatePicker from "../Inputs/FormDatePicker";
import FormInputText from "../Inputs/FormInputText";
import FormRadio from "../Inputs/FormRadio";
import FormSelect from "../Inputs/FormSelect";
import FormTextArea from "../Inputs/FormTextArea";
import FormDateRangePicker from "../Inputs/FormDateRangePicker";
import FormToggle from "../Inputs/FormToggle";
import FormMultiSelect from "../Inputs/FormMultiSelect";
import  FormPhoneText  from "../Inputs/FormPhoneText";
import  FormSsnText  from "../Inputs/FormSsnText";

export const renderInputField = (inputProps: InputFieldProps) => {
  switch (inputProps.type) {
    case "checkbox":
      return <FormCheckBox {...inputProps} key={inputProps.name} />;
    case "radio":
      return <FormRadio {...inputProps} key={inputProps.name} />;
    case "switch":
      return <FormToggle {...inputProps} key={inputProps.name} />;
    case "autocomplete":
      return <FormAutoComplete {...inputProps} key={inputProps.name} />;
    case "textarea":
      return <FormTextArea {...inputProps} key={inputProps.name} />;
    case "phone":
      return <FormPhoneText {...inputProps} key={inputProps.name} />;
    case "ssn":
      return <FormSsnText {...inputProps} key={inputProps.name} />;
     
      case "file":
      return (
        <>
          <FormLabel>{inputProps.label}</FormLabel>
          <FormInputText {...inputProps} key={inputProps.name} />
        </>
      );
    case "datepicker":
      return <FormDatePicker {...inputProps} key={inputProps.name} />;
    case "date-range-picker":
      return <FormDateRangePicker {...inputProps} key={inputProps.name} />;
    case "select":
      return <FormSelect {...inputProps} key={inputProps.name} />;
    case "multi-select":
      return <FormMultiSelect {...inputProps} key={inputProps.name} />;
    case "custom":
      return <inputProps.component {...inputProps} key={inputProps.name} />;
    default:
      return <FormInputText {...inputProps} key={inputProps.name} />;
  }
};
